<template>
  <div>
    <vm-table
        ref="vmTable"
        height="50vh"
        :filter.sync="filter"
        module="basic"
        url="YiXinShipmentApplication"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar">
        <el-button type="primary" @click="buyListDownLoadFile()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="状态">
            <el-select v-model.trim="filter.status">
              <el-option label="全部" :value="-1"/>
              <el-option label="未确认" :value="0"/>
              <el-option label="已确认" :value="1"/>
              <el-option label="已完结" :value="2"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55" fixed="left"/>
      <el-table-column prop="status" align="center" width="70" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0 ">未提交</span>
          <span v-if="scope.row.status === 1 ">已提交</span>
          <span v-if="scope.row.status === 2 ">已完结</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" align="center" width="200" label="标题"/>
      <el-table-column prop="applicationNo" align="center" width="150" label="流程编号">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.applicationNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" align="center" width="100" label="申请人"/>
      <el-table-column prop="customerName" align="center" width="200" label="申请公司"/>
      <el-table-column prop="createTime" align="center" width="200" label="创建日期"/>
      <el-table-column prop="unitCustomerName" align="center" width="150" label="合同单位全称"/>
      <el-table-column prop="factoryNos" align="center" label="出厂编号" show-overflow-tooltip/>
      <el-table-column prop="deliveryDate" align="center" width="200" label="客户要求交货期"/>
      <el-table-column
          label="操作"
          width="200"
          align="center"
          fixed="right"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button
              type="primary"
              :disabled="scope.row.status!==0"
              @click="$refs.yiXinApplicationEdit.open(scope.row.pkid,1)">
            编辑
          </el-button>
          <el-button
              type="primary"
              :disabled="scope.row.status!==0"
              @click="submit(scope.row)">
            提交
          </el-button>
          <el-button
              type="danger"
              :disabled="scope.row.status!==0 "
              @click="deleteOne(scope.row.pkid)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <yi-xin-application-edit ref="yiXinApplicationEdit" @save-sucess="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import yiXinApplicationEdit from "@/views/salesManage/yiXinShipmentApplication/yiXinApplicationEdit";

  export default {
    name: "YiXinShipmentApplicationList",
    components: {VmTable, VmSearch, yiXinApplicationEdit},
    data() {
      return {
        selection: [],
        filter: {
          status: -1,
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {

      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      deleteOne(pkid) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "YiXinShipmentApplication", pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      //下载清单
      buyListDownLoadFile() {
        this.downloadLoading = true;
        this.$http
          .exportFile("basic", "tianchangProductionOrder/export", this.filter)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
      },

      submit(row) {
        this.$http.get("basic", `YiXinShipmentApplication/submit/${row.pkid}`)
          .then(() => {
            this.$message.success("提交成功");
            this.getList(1);
          }).catch(() => {
            this.$message.error("提交失败");
            this.getList(1);
          });
      },

      goto(row){
        console.log(row);
        this.$router.push({
          path: "/yiXinApplicationPreview",
          query: {
            billId: row.pkid,
          },
        });
      },


    },
  };
</script>
<style lang="scss" scoped>
</style>
